import React from "react";
import ProfileForm from "../../../shared/ProfileForm/ProfileForm";

function ProfileFromAddUser(props) {
  return <ProfileForm></ProfileForm>;
}

export default ProfileFromAddUser;
